// Module
var code = "<template> <require from=\"app/core/components/documents/documents-grid\"></require> <documents-grid cache-key=\"UM_AUTH_DOCUMENTS_PAGE_CACHE\" target-id.bind=\"authId\" documents-config.bind=\"documentsConfig\" readonly.bind=\"readonly\"></documents-grid> </template> ";
// Exports
module.exports = code;